import { registerPlugin } from '@capacitor/core';

interface IAppleLoginPlugin {
  authorize: () => Promise<IUserInfos>;
}

export const AppleLoginPlugin = registerPlugin<IAppleLoginPlugin>('AppleLoginPlugin');
